import { render, staticRenderFns } from "./BIM.vue?vue&type=template&id=2c714840&scoped=true&"
var script = {}
import style0 from "./BIM.vue?vue&type=style&index=0&id=2c714840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c714840",
  null
  
)

export default component.exports